export class User {
  constructor(
    public dateOfBirth?: any,
    public emailVerified?: boolean,
    public firstName?: string,
    public id?: string,
    public lastName?: string,
    public name?: string,
    public phone?: string,
    public profilePictureUrl? : string 
  ) {}
}

export class BusinessType {
  constructor (
  public description?: string,
  public id?: number,
  public name?: string
  ) {}
}

export class UserModel {
  constructor (
    public address?: string,
    public businessTypes?: BusinessType[],
    public canReceiveNotifications?: boolean,
    public companyId?: string,
    public companyName?: string,
    public taxNumber?: string,
    public user?: User
  ) {}
}

export class UserModelRequest {
  constructor (
    public FirstName?: string,
    public LastName?: string,
    public Phone?: string,
    public DateOfBirth?: string | null
  ) {}
}
  